// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_I","nextBtn":"aJ","prevBtn":"bJ"};